// Shared state for the "Available Stock" detail popup
// ---------------------------------------------------
// The popup (components/TickerDetailModal.vue) is mounted once in App.vue and
// can be opened from anywhere: clicking a ticker headline, or the "available
// stock" link under the Types of Trailers section on the homepage.
//
// Only ticker items that have `detail` or `images` count as stock entries (see
// data/inventoryTicker.js). When more than one exists, the popup shows arrows
// to cycle between them.

import { reactive, toRaw } from 'vue'
import { inventoryTicker } from '../data/inventoryTicker.js'

export function hasStockDetail(item) {
  return !!(item && (item.detail || (item.images && item.images.length)))
}

// Stock entries the popup can show (empty when the ticker is switched off).
export const stockItems = inventoryTicker.active
  ? (inventoryTicker.items || []).filter(hasStockDetail)
  : []

export const hasAvailableStock = stockItems.length > 0

// `index` is the stock entry currently shown, or null when the popup is closed.
export const stockViewer = reactive({
  index: null,
})

// Open the popup on a specific ticker item, or on the first entry if omitted.
export function openStockViewer(item) {
  if (!hasAvailableStock) return
  // toRaw: callers like the ticker hold reactive proxies of the same items.
  const i = item ? stockItems.indexOf(toRaw(item)) : 0
  stockViewer.index = i >= 0 ? i : 0
}

export function closeStockViewer() {
  stockViewer.index = null
}

// Step forward/back through the entries, wrapping at either end.
export function stepStockViewer(delta) {
  if (stockViewer.index === null || stockItems.length < 2) return
  const n = stockItems.length
  stockViewer.index = (stockViewer.index + delta + n) % n
}
